import { Component, forwardRef, input } from '@angular/core';
import { InspectionDetailDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-inspection-type-select',
  templateUrl: './inspection-type-select.component.html',
  styleUrls: ['./inspection-type-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InspectionTypeSelectComponent),
      multi: true,
    },
  ],
})
export class InspectionTypeSelectComponent extends AbstractFormControl<InspectionDetailDto.InspectionTypeEnum | undefined> {
  readonly InspectionTypes = InspectionDetailDto.InspectionTypeEnum;

  readonly showEmptyOption = input(false);
}
